import React, {useEffect, useState} from 'react';
import {
  ButtonBack,
  ButtonBackText,
  ButtonConfirm,
  ButtonConfirmText,
  ButtonContainer,
  Container,
  ContainerIcons,
  ContainerStationHeader,
  Distance,
  DistanceIcon,
  MapIcon,
  MapIconButton,
  MapTitle,
  MarkerView,
  ModalBody,
  ModalContent,
  ModalFooter,
  OpenMapIcons,
  OpenMapsContainer,
  OpenMapsTitle,
  StationAddress,
  StationHeader,
  StationInfos,
  StationName,
  StationNameModal,
} from './styles';
import MapView, {Marker as NativeMarker} from 'react-native-maps';
import {StationDTO} from '../../../dtos/StationDTO';
import {useTheme} from 'styled-components/native';

import {GetAppResult, getApps} from 'react-native-map-link';
import {SafeAreaView} from 'react-native-safe-area-context';
import {Platform} from 'react-native';

//@ts-ignore react-native-web-maps only exposes Marker as a MapView static, not a named export
const Marker = Platform.OS === 'web' ? MapView.Marker : NativeMarker;

interface Props {
  showModal: boolean;
  onDismiss: () => void;
  data: StationDTO;
  rank?: 'gold' | 'silver' | undefined;
  codigo?: string;
  name?: string;
  productType?: string;

  onConfirm: () => void;
}

export function ConfirmPostModal({
  showModal,
  onDismiss,
  data,
  onConfirm,
}: Props) {
  const theme = useTheme();

  const [maps, setMaps] = useState<GetAppResult[]>([] as GetAppResult[]);

  useEffect(() => {
    async function getMaps() {
      const apps = await getApps({
        appsWhiteList: ['waze', 'apple-maps', 'google-maps'],
        directionsMode: 'car',
        latitude: data.lat,
        longitude: data.lng,
      });

      setMaps(apps);
    }

    if (showModal) {
      getMaps();
    }
  }, [showModal]);

  function handlePosto() {
    onDismiss();

    onConfirm();
  }

  return (
    <Container
      isVisible={showModal}
      onBackButtonPress={onDismiss}
      onBackdropPress={onDismiss}>
      <ModalContent>
        <ContainerStationHeader>
          <StationHeader
            region={{
              latitude: data.lat,
              longitude: data.lng,
              latitudeDelta: 0.0012,
              longitudeDelta: 0.0024,
            }}
            showsUserLocation
            customMapStyle={theme.mapstyle}>
            {Platform.OS !== 'web' ? (
              <Marker
                key={data.name}
                coordinate={{
                  latitude: data.lat,
                  longitude: data.lng,
                }}
                title={data.name}>
                <MarkerView
                  source={{
                    uri: data.flag_image,
                  }}
                />
              </Marker>
            ) : (
              <Marker
                key={data.name}
                coordinate={{
                  latitude: data.lat,
                  longitude: data.lng,
                }}
                title={data.name}
              />
            )}
          </StationHeader>
        </ContainerStationHeader>
        <ModalBody>
          <StationInfos>
            <StationNameModal>
              <StationName numberOfLines={1} ellipsizeMode="tail">
                {data.name}
              </StationName>
              <StationAddress numberOfLines={1} ellipsizeMode="tail">
                {data.address}
              </StationAddress>
            </StationNameModal>
            {data.distance && (
              <ContainerIcons>
                <DistanceIcon name="map-pin" />
                <Distance>{data.distance} km</Distance>
              </ContainerIcons>
            )}
          </StationInfos>
          <OpenMapsContainer>
            <OpenMapsTitle>Escolha seu aplicativo de navegação:</OpenMapsTitle>
            <OpenMapIcons>
              {maps.map(map => (
                <MapIconButton
                  activeOpacity={0.7}
                  onPress={map.open}
                  key={map.id}>
                  <MapIcon source={map.icon} />
                  <MapTitle>{map.name}</MapTitle>
                </MapIconButton>
              ))}
            </OpenMapIcons>
          </OpenMapsContainer>
        </ModalBody>
        <ModalFooter>
          <SafeAreaView>
            <ButtonContainer>
              <ButtonBack onPress={onDismiss} activeOpacity={0.7}>
                <ButtonBackText>Voltar</ButtonBackText>
              </ButtonBack>
              <ButtonConfirm onPress={handlePosto} activeOpacity={0.7}>
                <ButtonConfirmText>Confirmar</ButtonConfirmText>
              </ButtonConfirm>
            </ButtonContainer>
          </SafeAreaView>
        </ModalFooter>
      </ModalContent>
    </Container>
  );
}
